import {
  EQuarter,
  ECurrency,
  EUserType,
  ERoleAccess,
  ESchoolStatus,
  ECommonStatus,
  ESupportStatus,
  EContentStatus,
  EDeviceUserType,
  ELessonStageType,
  ERestoreEntityType,
  ESubscriptionStatus,
} from '@/enum';

export const SectionNameConfig = {
  [ERoleAccess.USER_MANAGEMENT]: 'sidebar.user-management',
  [ERoleAccess.CONTENT_MANAGEMENT]: 'sidebar.content-management',
  [ERoleAccess.REPORTS_ANALYTICS]: 'sidebar.reports-analytics',
  [ERoleAccess.DEVICE_MANAGEMENT]: 'sidebar.device-management',
  [ERoleAccess.SETTINGS_ROLES]: 'sidebar.roles-permissions',
  [ERoleAccess.SUPPORT_QUERIES]: 'sidebar.support-queries',
  [ERoleAccess.NOTIFICATIONS]: 'sidebar.notifications',
  [ERoleAccess.EDITORIAL_MANAGEMENT]: 'sidebar.editorial-management',
  [ERoleAccess.MAINTENANCE_MODE]: 'sidebar.maintenance-mode',
};

export const colors = [
  'bg-indigo-400',
  'bg-teal-400',
  'bg-pink-400',
  'bg-purple-400',
  'bg-orange-400',
  'bg-lime-400',
  'bg-cyan-400',
  'bg-fuchsia-400',
];

export const VALIDATION_MESSAGES = {
  email: {
    required: 'errors.email.required',
    min: 'errors.email.min',
    max: 'errors.email.max',
    invalid: 'errors.email.invalid',
  },
  password: {
    required: 'errors.password.required',
    min: 'errors.password.min',
    max: 'errors.password.max',
    strength: 'errors.password.strength',
  },
  currentPassword: {
    required: 'errors.current-password.required',
    min: 'errors.current-password.min',
    max: 'errors.current-password.max',
  },
  confirmPassword: {
    required: 'errors.confirm-password.required',
    min: 'errors.confirm-password.min',
    max: 'errors.confirm-password.max',
    strength: 'errors.confirm-password.strength',
    match: 'errors.confirm-password.match',
  },
  schoolName: {
    required: 'errors.add-school.name.required',
    min: 'errors.add-school.name.min',
    max: 'errors.add-school.name.max',
    invalid: 'errors.add-school.name.invalid',
  },
  schoolEmail: {
    required: 'errors.add-school.email.required',
    min: 'errors.add-school.email.min',
    max: 'errors.add-school.email.max',
    invalid: 'errors.add-school.email.invalid',
  },
  mobileNumber: {
    required: 'errors.add-school.phone.required',
    invalid: 'errors.add-school.phone.invalid',
  },
  countryCode: {
    invalid: 'errors.add-school.country-code.invalid',
  },
  profileImage: {
    invalid: 'errors.add-school.profile-image.invalid-type',
    maxSize: 'errors.add-school.profile-image.max-size',
  },
  studentLimit: {
    required: 'errors.add-school.student-limit.required',
    min: 'errors.add-school.student-limit.min',
    invalid: 'errors.add-school.student-limit.invalid',
  },
  amount: {
    required: 'errors.add-school.amount.required',
    invalid: 'errors.add-school.amount.invalid',
  },
  subscriptionStartDate: {
    required: 'errors.add-school.subscription-start-date.required',
    invalid: 'errors.add-school.subscription-start-date.invalid',
  },
  subscriptionEndDate: {
    required: 'errors.add-school.subscription-end-date.required',
    beforeStart: 'errors.add-school.subscription-end-date.before-start',
  },
  transactionId: {
    required: 'errors.add-school.transaction-id.required',
    min: 'errors.add-school.transaction-id.min',
    max: 'errors.add-school.transaction-id.max',
    invalid: 'errors.add-school.transaction-id.invalid',
  },
  currency: {
    required: 'errors.add-school.currency.required',
  },
  adminName: {
    required: 'errors.add-admin.name.required',
    min: 'errors.add-admin.name.min',
    max: 'errors.add-admin.name.max',
  },
  adminEmail: {
    required: 'errors.add-admin.email.required',
    min: 'errors.add-admin.email.min',
    max: 'errors.add-admin.email.max',
    invalid: 'errors.add-admin.email.invalid',
  },
  adminRole: {
    required: 'errors.add-admin.role.required',
  },
  roleName: {
    required: 'errors.add-role.name.required',
    min: 'errors.add-role.name.min',
    max: 'errors.add-role.name.max',
  },
  roleDescription: {
    max: 'errors.add-role.description.max',
  },
  faq: {
    question: {
      required: 'errors.add-faq.question.required',
      min: 'errors.add-faq.question.min',
      max: 'errors.add-faq.question.max',
    },
    answer: {
      required: 'errors.add-faq.answer.required',
      min: 'errors.add-faq.answer.min',
      max: 'errors.add-faq.answer.max',
    },
    userType: {
      required: 'errors.add-faq.user-type.required',
    },
  },
  policy: {
    name: {
      required: 'errors.add-policy.name.required',
      min: 'errors.add-policy.name.min',
      max: 'errors.add-policy.name.max',
    },
    description: {
      required: 'errors.add-policy.description.required',
      min: 'errors.add-policy.description.min',
      max: 'errors.add-policy.description.max',
    },
  },
  discardSupport: {
    reason: {
      required: 'errors.discard-issue.reason.required',
      min: 'errors.discard-issue.reason.min',
      max: 'errors.discard-issue.reason.max',
    },
  },
  notification: {
    title: {
      required: 'errors.add-notification.title.required',
      min: 'errors.add-notification.title.min',
      max: 'errors.add-notification.title.max',
    },
    description: {
      required: 'errors.add-notification.description.required',
      min: 'errors.add-notification.description.min',
      max: 'errors.add-notification.description.max',
    },
    targetedUser: {
      required: 'errors.add-notification.targeted-user.required',
    },
    type: {
      required: 'errors.add-notification.type.required',
    },
    date: {
      required: 'errors.add-notification.date.required',
    },
    time: {
      required: 'errors.add-notification.time.required',
    },
  },
  scheduleRenewal: {
    studentLimit: {
      required: 'errors.schedule-renewal.student-seats.required',
      min: 'errors.schedule-renewal.student-seats.min',
      max: 'errors.schedule-renewal.student-seats.max',
      invalid: 'errors.schedule-renewal.student-seats.invalid',
    },
    amount: {
      required: 'errors.schedule-renewal.amount.required',
      min: 'errors.schedule-renewal.amount.min',
      max: 'errors.schedule-renewal.amount.max',
    },
    currency: {
      required: 'errors.schedule-renewal.currency.required',
    },
    subscriptionStartDate: {
      required: 'errors.schedule-renewal.subscription-start-date.required',
      invalid: 'errors.schedule-renewal.subscription-start-date.invalid',
    },
    subscriptionEndDate: {
      required: 'errors.schedule-renewal.subscription-end-date.required',
      invalid: 'errors.schedule-renewal.subscription-end-date.invalid',
    },
    transactionId: {
      required: 'errors.schedule-renewal.transaction-id.required',
      min: 'errors.schedule-renewal.transaction-id.min',
      max: 'errors.schedule-renewal.transaction-id.max',
    },
  },
  editSubscription: {
    endDateBelowCurrent: 'errors.edit-subscription.end-date.below-current',
  },
};

export const SchoolStatusConfig = {
  [ESchoolStatus.ACTIVE]: {
    label: 'common.status.active',
    className: 'bg-success-light-50 text-success-secondary',
  },
  [ESchoolStatus.IN_ACTIVE]: {
    label: 'common.status.inactive',
    className: 'bg-warning-light-100 text-warning-secondary',
  },
};

export const CommonStatusConfig = {
  [ECommonStatus.ACTIVE]: {
    label: 'common.status.active',
    className: 'bg-success-light-50 text-success-secondary',
  },
  [ECommonStatus.IN_ACTIVE]: {
    label: 'common.status.inactive',
    className: 'bg-warning-light-100 text-warning-secondary',
  },
};

export const AccessStatusConfig = {
  full: {
    label: 'settings.roles.full-access',
    className: 'bg-success-light-50 text-success-secondary',
  },
  limited: {
    label: 'settings.roles.limited-access',
    className: 'bg-indigo-light-50 text-indigo-secondary',
  },
};

export const COMMON_SERVICE_STRINGS = {
  SUCCESS_MSG: 'Operation successful',
  ERROR_MSG: 'Something went wrong',
};

export const countryCodeData = [
  { phone: '+93', name: 'Afghanistan', id: 1, code: 'AF' },
  { phone: '+358', name: 'Åland Islands', id: 2, code: 'AX' },
  { phone: '+355', name: 'Albania', id: 3, code: 'AL' },
  { phone: '+213', name: 'Algeria', id: 4, code: 'DZ' },
  { phone: '+1', name: 'American Samoa', id: 5, code: 'AS' },
  { phone: '+376', name: 'Andorra', id: 6, code: 'AD' },
  { phone: '+244', name: 'Angola', id: 7, code: 'AO' },
  { phone: '+1', name: 'Anguilla', id: 8, code: 'AI' },
  { phone: '+672', name: 'Antarctica', id: 9, code: 'AQ' },
  { phone: '+1', name: 'Antigua and Barbuda', id: 10, code: 'AG' },
  { phone: '+54', name: 'Argentina', id: 11, code: 'AR' },
  { phone: '+374', name: 'Armenia', id: 12, code: 'AM' },
  { phone: '+297', name: 'Aruba', id: 13, code: 'AW' },
  { phone: '+61', name: 'Australia', id: 14, code: 'AU' },
  { phone: '+43', name: 'Austria', id: 15, code: 'AT' },
  { phone: '+994', name: 'Azerbaijan', id: 16, code: 'AZ' },
  { phone: '+1', name: 'Bahamas', id: 17, code: 'BS' },
  { phone: '+973', name: 'Bahrain', id: 18, code: 'BH' },
  { phone: '+880', name: 'Bangladesh', id: 19, code: 'BD' },
  { phone: '+1', name: 'Barbados', id: 20, code: 'BB' },
  { phone: '+375', name: 'Belarus', id: 21, code: 'BY' },
  { phone: '+32', name: 'Belgium', id: 22, code: 'BE' },
  { phone: '+501', name: 'Belize', id: 23, code: 'BZ' },
  { phone: '+229', name: 'Benin', id: 24, code: 'BJ' },
  { phone: '+1', name: 'Bermuda', id: 25, code: 'BM' },
  { phone: '+975', name: 'Bhutan', id: 26, code: 'BT' },
  {
    phone: '+591',
    name: 'Bolivia (Plurinational State of)',
    id: 27,
    code: 'BO',
  },
  { phone: '+387', name: 'Bosnia and Herzegovina', id: 28, code: 'BA' },
  { phone: '+267', name: 'Botswana', id: 29, code: 'BW' },
  { phone: '+55', name: 'Bouvet Island', id: 30, code: 'BV' },
  { phone: '+55', name: 'Brazil', id: 31, code: 'BR' },
  { phone: '+246', name: 'British Indian Ocean Territory', id: 32, code: 'IO' },
  { phone: '+673', name: 'Brunei Darussalam', id: 33, code: 'BN' },
  { phone: '+359', name: 'Bulgaria', id: 34, code: 'BG' },
  { phone: '+226', name: 'Burkina Faso', id: 35, code: 'BF' },
  { phone: '+257', name: 'Burundi', id: 36, code: 'BI' },
  { phone: '+238', name: 'Cabo Verde', id: 37, code: 'CV' },
  { phone: '+855', name: 'Cambodia', id: 38, code: 'KH' },
  { phone: '+237', name: 'Cameroon', id: 39, code: 'CM' },
  { phone: '+1', name: 'Canada', id: 40, code: 'CA' },
  { phone: '+599', name: 'Caribbean Netherlands', id: 41, code: 'BQ' },
  { phone: '+1', name: 'Cayman Islands', id: 42, code: 'KY' },
  { phone: '+236', name: 'Central African Republic', id: 43, code: 'CF' },
  { phone: '+235', name: 'Chad', id: 44, code: 'TD' },
  { phone: '+56', name: 'Chile', id: 45, code: 'CL' },
  { phone: '+86', name: 'China', id: 46, code: 'CN' },
  { phone: '+61', name: 'Christmas Island', id: 47, code: 'CX' },
  { phone: '+61', name: 'Cocos (Keeling) Islands', id: 48, code: 'CC' },
  { phone: '+57', name: 'Colombia', id: 49, code: 'CO' },
  { phone: '+269', name: 'Comoros', id: 50, code: 'KM' },
  { phone: '+242', name: 'Congo', id: 51, code: 'CG' },
  {
    phone: '+243',
    name: 'Congo, Democratic Republic of the',
    id: 52,
    code: 'CD',
  },
  { phone: '+682', name: 'Cook Islands', id: 53, code: 'CK' },
  { phone: '+506', name: 'Costa Rica', id: 54, code: 'CR' },
  { phone: '+385', name: 'Croatia', id: 55, code: 'HR' },
  { phone: '+53', name: 'Cuba', id: 56, code: 'CU' },
  { phone: '+599', name: 'Curaçao', id: 57, code: 'CW' },
  { phone: '+357', name: 'Cyprus', id: 58, code: 'CY' },
  { phone: '+420', name: 'Czech Republic', id: 59, code: 'CZ' },
  { phone: '+225', name: "Côte d'Ivoire", id: 60, code: 'CI' },
  { phone: '+45', name: 'Denmark', id: 61, code: 'DK' },
  { phone: '+253', name: 'Djibouti', id: 62, code: 'DJ' },
  { phone: '+1', name: 'Dominica', id: 63, code: 'DM' },
  { phone: '+1', name: 'Dominican Republic', id: 64, code: 'DO' },
  { phone: '+593', name: 'Ecuador', id: 65, code: 'EC' },
  { phone: '+20', name: 'Egypt', id: 66, code: 'EG' },
  { phone: '+503', name: 'El Salvador', id: 67, code: 'SV' },
  { phone: '+240', name: 'Equatorial Guinea', id: 68, code: 'GQ' },
  { phone: '+291', name: 'Eritrea', id: 69, code: 'ER' },
  { phone: '+372', name: 'Estonia', id: 70, code: 'EE' },
  { phone: '+268', name: 'Eswatini (Swaziland)', id: 71, code: 'SZ' },
  { phone: '+251', name: 'Ethiopia', id: 72, code: 'ET' },
  { phone: '+500', name: 'Falkland Islands (Malvinas)', id: 73, code: 'FK' },
  { phone: '+298', name: 'Faroe Islands', id: 74, code: 'FO' },
  { phone: '+679', name: 'Fiji', id: 75, code: 'FJ' },
  { phone: '+358', name: 'Finland', id: 76, code: 'FI' },
  { phone: '+33', name: 'France', id: 77, code: 'FR' },
  { phone: '+594', name: 'French Guiana', id: 78, code: 'GF' },
  { phone: '+689', name: 'French Polynesia', id: 79, code: 'PF' },
  { phone: '+262', name: 'French Southern Territories', id: 80, code: 'TF' },
  { phone: '+241', name: 'Gabon', id: 81, code: 'GA' },
  { phone: '+220', name: 'Gambia', id: 82, code: 'GM' },
  { phone: '+995', name: 'Georgia', id: 83, code: 'GE' },
  { phone: '+49', name: 'Germany', id: 84, code: 'DE' },
  { phone: '+233', name: 'Ghana', id: 85, code: 'GH' },
  { phone: '+350', name: 'Gibraltar', id: 86, code: 'GI' },
  { phone: '+30', name: 'Greece', id: 87, code: 'GR' },
  { phone: '+299', name: 'Greenland', id: 88, code: 'GL' },
  { phone: '+1', name: 'Grenada', id: 89, code: 'GD' },
  { phone: '+590', name: 'Guadeloupe', id: 90, code: 'GP' },
  { phone: '+1', name: 'Guam', id: 91, code: 'GU' },
  { phone: '+502', name: 'Guatemala', id: 92, code: 'GT' },
  { phone: '+44', name: 'Guernsey', id: 93, code: 'GG' },
  { phone: '+224', name: 'Guinea', id: 94, code: 'GN' },
  { phone: '+245', name: 'Guinea-Bissau', id: 95, code: 'GW' },
  { phone: '+592', name: 'Guyana', id: 96, code: 'GY' },
  { phone: '+509', name: 'Haiti', id: 97, code: 'HT' },
  {
    phone: '+61',
    name: 'Heard Island and Mcdonald Islands',
    id: 98,
    code: 'HM',
  },
  { phone: '+504', name: 'Honduras', id: 99, code: 'HN' },
  { phone: '+852', name: 'Hong Kong', id: 100, code: 'HK' },
  { phone: '+36', name: 'Hungary', id: 101, code: 'HU' },
  { phone: '+354', name: 'Iceland', id: 102, code: 'IS' },
  { phone: '+91', name: 'India', id: 103, code: 'IN' },
  { phone: '+62', name: 'Indonesia', id: 104, code: 'ID' },
  { phone: '+98', name: 'Iran', id: 105, code: 'IR' },
  { phone: '+964', name: 'Iraq', id: 106, code: 'IQ' },
  { phone: '+353', name: 'Ireland', id: 107, code: 'IE' },
  { phone: '+44', name: 'Isle of Man', id: 108, code: 'IM' },
  { phone: '+972', name: 'Israel', id: 109, code: 'IL' },
  { phone: '+39', name: 'Italy', id: 110, code: 'IT' },
  { phone: '+1', name: 'Jamaica', id: 111, code: 'JM' },
  { phone: '+81', name: 'Japan', id: 112, code: 'JP' },
  { phone: '+44', name: 'Jersey', id: 113, code: 'JE' },
  { phone: '+962', name: 'Jordan', id: 114, code: 'JO' },
  { phone: '+7', name: 'Kazakhstan', id: 115, code: 'KZ' },
  { phone: '+254', name: 'Kenya', id: 116, code: 'KE' },
  { phone: '+686', name: 'Kiribati', id: 117, code: 'KI' },
  { phone: '+850', name: 'Korea, North', id: 118, code: 'KP' },
  { phone: '+82', name: 'Korea, South', id: 119, code: 'KR' },
  { phone: '+383', name: 'Kosovo', id: 120, code: 'XK' },
  { phone: '+965', name: 'Kuwait', id: 121, code: 'KW' },
  { phone: '+996', name: 'Kyrgyzstan', id: 122, code: 'KG' },
  {
    phone: '+856',
    name: "Lao People's Democratic Republic",
    id: 123,
    code: 'LA',
  },
  { phone: '+371', name: 'Latvia', id: 124, code: 'LV' },
  { phone: '+961', name: 'Lebanon', id: 125, code: 'LB' },
  { phone: '+266', name: 'Lesotho', id: 126, code: 'LS' },
  { phone: '+231', name: 'Liberia', id: 127, code: 'LR' },
  { phone: '+218', name: 'Libya', id: 128, code: 'LY' },
  { phone: '+423', name: 'Liechtenstein', id: 129, code: 'LI' },
  { phone: '+370', name: 'Lithuania', id: 130, code: 'LT' },
  { phone: '+352', name: 'Luxembourg', id: 131, code: 'LU' },
  { phone: '+853', name: 'Macao', id: 132, code: 'MO' },
  { phone: '+389', name: 'Macedonia North', id: 133, code: 'MK' },
  { phone: '+261', name: 'Madagascar', id: 134, code: 'MG' },
  { phone: '+265', name: 'Malawi', id: 135, code: 'MW' },
  { phone: '+60', name: 'Malaysia', id: 136, code: 'MY' },
  { phone: '+960', name: 'Maldives', id: 137, code: 'MV' },
  { phone: '+223', name: 'Mali', id: 138, code: 'ML' },
  { phone: '+356', name: 'Malta', id: 139, code: 'MT' },
  { phone: '+692', name: 'Marshall Islands', id: 140, code: 'MH' },
  { phone: '+596', name: 'Martinique', id: 141, code: 'MQ' },
  { phone: '+222', name: 'Mauritania', id: 142, code: 'MR' },
  { phone: '+230', name: 'Mauritius', id: 143, code: 'MU' },
  { phone: '+262', name: 'Mayotte', id: 144, code: 'YT' },
  { phone: '+52', name: 'Mexico', id: 145, code: 'MX' },
  { phone: '+691', name: 'Micronesia', id: 146, code: 'FM' },
  { phone: '+373', name: 'Moldova', id: 147, code: 'MD' },
  { phone: '+377', name: 'Monaco', id: 148, code: 'MC' },
  { phone: '+976', name: 'Mongolia', id: 149, code: 'MN' },
  { phone: '+382', name: 'Montenegro', id: 150, code: 'ME' },
  { phone: '+1', name: 'Montserrat', id: 151, code: 'MS' },
  { phone: '+212', name: 'Morocco', id: 152, code: 'MA' },
  { phone: '+258', name: 'Mozambique', id: 153, code: 'MZ' },
  { phone: '+95', name: 'Myanmar (Burma)', id: 154, code: 'MM' },
  { phone: '+264', name: 'Namibia', id: 155, code: 'NA' },
  { phone: '+674', name: 'Nauru', id: 156, code: 'NR' },
  { phone: '+977', name: 'Nepal', id: 157, code: 'NP' },
  { phone: '+31', name: 'Netherlands', id: 158, code: 'NL' },
  { phone: '+687', name: 'New Caledonia', id: 159, code: 'NC' },
  { phone: '+64', name: 'New Zealand', id: 160, code: 'NZ' },
  { phone: '+505', name: 'Nicaragua', id: 161, code: 'NI' },
  { phone: '+227', name: 'Niger', id: 162, code: 'NE' },
  { phone: '+234', name: 'Nigeria', id: 163, code: 'NG' },
  { phone: '+683', name: 'Niue', id: 164, code: 'NU' },
  { phone: '+672', name: 'Norfolk Island', id: 165, code: 'NF' },
  { phone: '+1', name: 'Northern Mariana Islands', id: 166, code: 'MP' },
  { phone: '+47', name: 'Norway', id: 167, code: 'NO' },
  { phone: '+968', name: 'Oman', id: 168, code: 'OM' },
  { phone: '+92', name: 'Pakistan', id: 169, code: 'PK' },
  { phone: '+680', name: 'Palau', id: 170, code: 'PW' },
  { phone: '+970', name: 'Palestine', id: 171, code: 'PS' },
  { phone: '+507', name: 'Panama', id: 172, code: 'PA' },
  { phone: '+675', name: 'Papua New Guinea', id: 173, code: 'PG' },
  { phone: '+595', name: 'Paraguay', id: 174, code: 'PY' },
  { phone: '+51', name: 'Peru', id: 175, code: 'PE' },
  { phone: '+63', name: 'Philippines', id: 176, code: 'PH' },
  { phone: '+64', name: 'Pitcairn Islands', id: 177, code: 'PN' },
  { phone: '+48', name: 'Poland', id: 178, code: 'PL' },
  { phone: '+351', name: 'Portugal', id: 179, code: 'PT' },
  { phone: '+1', name: 'Puerto Rico', id: 180, code: 'PR' },
  { phone: '+974', name: 'Qatar', id: 181, code: 'QA' },
  { phone: '+262', name: 'Reunion', id: 182, code: 'RE' },
  { phone: '+40', name: 'Romania', id: 183, code: 'RO' },
  { phone: '+7', name: 'Russian Federation', id: 184, code: 'RU' },
  { phone: '+250', name: 'Rwanda', id: 185, code: 'RW' },
  { phone: '+590', name: 'Saint Barthelemy', id: 186, code: 'BL' },
  { phone: '+290', name: 'Saint Helena', id: 187, code: 'SH' },
  { phone: '+1', name: 'Saint Kitts and Nevis', id: 188, code: 'KN' },
  { phone: '+1', name: 'Saint Lucia', id: 189, code: 'LC' },
  { phone: '+590', name: 'Saint Martin', id: 190, code: 'MF' },
  { phone: '+508', name: 'Saint Pierre and Miquelon', id: 191, code: 'PM' },
  {
    phone: '+1',
    name: 'Saint Vincent and the Grenadines',
    id: 192,
    code: 'VC',
  },
  { phone: '+685', name: 'Samoa', id: 193, code: 'WS' },
  { phone: '+378', name: 'San Marino', id: 194, code: 'SM' },
  { phone: '+239', name: 'Sao Tome and Principe', id: 195, code: 'ST' },
  { phone: '+966', name: 'Saudi Arabia', id: 196, code: 'SA' },
  { phone: '+221', name: 'Senegal', id: 197, code: 'SN' },
  { phone: '+381', name: 'Serbia', id: 198, code: 'RS' },
  { phone: '+248', name: 'Seychelles', id: 199, code: 'SC' },
  { phone: '+232', name: 'Sierra Leone', id: 200, code: 'SL' },
  { phone: '+65', name: 'Singapore', id: 201, code: 'SG' },
  { phone: '+1', name: 'Sint Maarten', id: 202, code: 'SX' },
  { phone: '+421', name: 'Slovakia', id: 203, code: 'SK' },
  { phone: '+386', name: 'Slovenia', id: 204, code: 'SI' },
  { phone: '+677', name: 'Solomon Islands', id: 205, code: 'SB' },
  { phone: '+252', name: 'Somalia', id: 206, code: 'SO' },
  { phone: '+27', name: 'South Africa', id: 207, code: 'ZA' },
  {
    phone: '+500',
    name: 'South Georgia and the South Sandwich Islands',
    id: 208,
    code: 'GS',
  },
  { phone: '+211', name: 'South Sudan', id: 209, code: 'SS' },
  { phone: '+34', name: 'Spain', id: 210, code: 'ES' },
  { phone: '+94', name: 'Sri Lanka', id: 211, code: 'LK' },
  { phone: '+249', name: 'Sudan', id: 212, code: 'SD' },
  { phone: '+597', name: 'Suriname', id: 213, code: 'SR' },
  { phone: '+47', name: 'Svalbard and Jan Mayen', id: 214, code: 'SJ' },
  { phone: '+46', name: 'Sweden', id: 215, code: 'SE' },
  { phone: '+41', name: 'Switzerland', id: 216, code: 'CH' },
  { phone: '+963', name: 'Syria', id: 217, code: 'SY' },
  { phone: '+886', name: 'Taiwan', id: 218, code: 'TW' },
  { phone: '+992', name: 'Tajikistan', id: 219, code: 'TJ' },
  { phone: '+255', name: 'Tanzania', id: 220, code: 'TZ' },
  { phone: '+66', name: 'Thailand', id: 221, code: 'TH' },
  { phone: '+670', name: 'Timor-Leste', id: 222, code: 'TL' },
  { phone: '+228', name: 'Togo', id: 223, code: 'TG' },
  { phone: '+690', name: 'Tokelau', id: 224, code: 'TK' },
  { phone: '+676', name: 'Tonga', id: 225, code: 'TO' },
  { phone: '+1', name: 'Trinidad and Tobago', id: 226, code: 'TT' },
  { phone: '+216', name: 'Tunisia', id: 227, code: 'TN' },
  { phone: '+90', name: 'Turkey (Türkiye)', id: 228, code: 'TR' },
  { phone: '+993', name: 'Turkmenistan', id: 229, code: 'TM' },
  { phone: '+1', name: 'Turks and Caicos Islands', id: 230, code: 'TC' },
  { phone: '+688', name: 'Tuvalu', id: 231, code: 'TV' },
  { phone: '+1', name: 'U.S. Outlying Islands', id: 232, code: 'UM' },
  { phone: '+256', name: 'Uganda', id: 233, code: 'UG' },
  { phone: '+380', name: 'Ukraine', id: 234, code: 'UA' },
  { phone: '+971', name: 'United Arab Emirates', id: 235, code: 'AE' },
  { phone: '+44', name: 'United Kingdom', id: 236, code: 'GB' },
  { phone: '+1', name: 'United States', id: 237, code: 'US' },
  { phone: '+598', name: 'Uruguay', id: 238, code: 'UY' },
  { phone: '+998', name: 'Uzbekistan', id: 239, code: 'UZ' },
  { phone: '+678', name: 'Vanuatu', id: 240, code: 'VU' },
  { phone: '+39', name: 'Vatican City Holy See', id: 241, code: 'VA' },
  { phone: '+58', name: 'Venezuela', id: 242, code: 'VE' },
  { phone: '+84', name: 'Vietnam', id: 243, code: 'VN' },
  { phone: '+1', name: 'Virgin Islands, British', id: 244, code: 'VG' },
  { phone: '+1', name: 'Virgin Islands, U.S', id: 245, code: 'VI' },
  { phone: '+681', name: 'Wallis and Futuna', id: 246, code: 'WF' },
  { phone: '+212', name: 'Western Sahara', id: 247, code: 'EH' },
  { phone: '+967', name: 'Yemen', id: 248, code: 'YE' },
  { phone: '+260', name: 'Zambia', id: 249, code: 'ZM' },
  { phone: '+263', name: 'Zimbabwe', id: 250, code: 'ZW' },
];

export const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'en' },
  { label: 'عربي', value: 'ar' },
];

export const STATUS_OPTIONS = [
  { value: 'active', label: 'common.status.active' },
  { value: 'in_active', label: 'common.status.inactive' },
];

export const LOGIN_DAYS_OPTIONS = [
  { value: '7', label: 'user-management.filters.login-days.last-7' },
  { value: '15', label: 'user-management.filters.login-days.last-15' },
  { value: '30', label: 'user-management.filters.login-days.last-30' },
];

export const SUBSCRIPTION_STATUS_OPTIONS = [
  {
    value: ESubscriptionStatus.ACTIVE,
    label: 'common.subscription-status.active',
  },
  {
    value: ESubscriptionStatus.EXPIRING_SOON,
    label: 'common.subscription-status.expiring-soon',
  },
  {
    value: ESubscriptionStatus.EXPIRED,
    label: 'common.subscription-status.expired',
  },
  {
    value: ESubscriptionStatus.CANCELLED,
    label: 'common.subscription-status.cancelled',
  },
  {
    value: ESubscriptionStatus.UPCOMING,
    label: 'common.subscription-status.upcoming',
  },
];

export const CHILDREN_STATUS_OPTIONS = [
  {
    label: 'common.status.active',
    value: 'active',
  },
  {
    label: 'common.status.inactive',
    value: 'in_active',
  },
];
export const LINKED_CHILDREN_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
];

// Lesson level config for label and color
export const LessonStageConfig: Record<
  ELessonStageType,
  { label: string; className: string }
> = {
  [ELessonStageType.EXPLORATION]: {
    label: 'user-management.filters.lesson-levels.exploration',
    className: 'bg-purple-light-50 text-purple-600',
  },
  [ELessonStageType.KICK_OFF]: {
    label: 'user-management.filters.lesson-levels.kick-off',
    className: 'bg-success-light-50 text-success-secondary',
  },
  [ELessonStageType.MASTERY]: {
    label: 'user-management.filters.lesson-levels.mastery',
    className: 'bg-indigo-50 text-indigo-600',
  },
  [ELessonStageType.CREATIVITY]: {
    label: 'user-management.filters.lesson-levels.creativity',
    className: 'bg-orange-50 text-orange-600',
  },
};

export const LESSON_STAGE_OPTIONS = [
  {
    value: String(ELessonStageType.EXPLORATION),
    label: 'user-management.filters.lesson-levels.exploration',
  },
  {
    value: String(ELessonStageType.KICK_OFF),
    label: 'user-management.filters.lesson-levels.kick-off',
  },
  {
    value: String(ELessonStageType.MASTERY),
    label: 'user-management.filters.lesson-levels.mastery',
  },
  {
    value: String(ELessonStageType.CREATIVITY),
    label: 'user-management.filters.lesson-levels.creativity',
  },
];

export const QUARTER_OPTIONS = [
  { value: String(EQuarter.Q1), label: 'Q1' },
  { value: String(EQuarter.Q2), label: 'Q2' },
  { value: String(EQuarter.Q3), label: 'Q3' },
  { value: String(EQuarter.Q4), label: 'Q4' },
];

export const DEVICE_USER_TYPE_OPTIONS = [
  {
    value: EDeviceUserType.STUDENT,
    label: 'device-management.filter.user-types.student',
  },
  {
    value: EDeviceUserType.CHILD,
    label: 'device-management.filter.user-types.child',
  },
  {
    value: EDeviceUserType.PARENT,
    label: 'device-management.filter.user-types.parent',
  },
];

export const FAQ_USER_OPTIONS = [
  {
    value: EUserType.PARENT,
    label: 'editorial.faq.modal.user-types.parent',
  },
  {
    value: EUserType.TEACHER,
    label: 'editorial.faq.modal.user-types.teacher',
  },
  {
    value: EUserType.SCHOOL,
    label: 'editorial.faq.modal.user-types.school',
  },
];

export const EDITOR_FONT_OPTIONS = [
  {
    value: 'sans-serif',
    label: 'Sans Serif',
  },
  { value: 'serif', label: 'Serif' },
  {
    value: 'monospace',
    label: 'Monospace',
  },
  {
    value: 'arial',
    label: 'Arial',
  },
  {
    value: 'times-new-roman',
    label: 'Times New Roman',
  },
  {
    value: 'courier-new',
    label: 'Courier New',
  },
  {
    value: 'georgia',
    label: 'Georgia',
  },
  {
    value: 'verdana',
    label: 'Verdana',
  },
];

export const SupportStatusConfig = {
  [ESupportStatus.PENDING]: {
    label: 'support.status.pending',
    className: 'bg-warning-light-100 text-warning-secondary',
  },
  [ESupportStatus.RESOLVED]: {
    label: 'support.status.resolved',
    className: 'bg-green-50 text-green-600',
  },
  [ESupportStatus.DISCARD]: {
    label: 'support.status.discard',
    className: 'bg-red-50 text-red-600',
  },
};

export const ContentStatusConfig = {
  [EContentStatus.ACTIVE]: {
    label: 'contentManagement.table.status.active',
    className: 'bg-success-light-50 text-success-secondary',
  },
  [EContentStatus.INACTIVE]: {
    label: 'contentManagement.table.status.inactive',
    className: 'bg-warning-light-100 text-warning-secondary',
  },
  [EContentStatus.DELETED]: {
    label: 'contentManagement.table.status.deleted',
    className: 'bg-error-light-50 text-error-secondary',
  },
};

export const CONTENT_STATUS_OPTIONS = [
  {
    value: EContentStatus.ACTIVE,
    label: 'contentManagement.table.status.active',
  },
  {
    value: EContentStatus.INACTIVE,
    label: 'contentManagement.table.status.inactive',
  },
  {
    value: EContentStatus.DELETED,
    label: 'contentManagement.table.status.deleted',
  },
];

export const SUPPORT_STATUS_OPTIONS = [
  { value: ESupportStatus.PENDING, label: 'support.status.pending' },
  { value: ESupportStatus.RESOLVED, label: 'support.status.resolved' },
  { value: ESupportStatus.DISCARD, label: 'support.status.discard' },
];

export const SupportUserTypeConfig = {
  [EUserType.PARENT]: {
    label: 'editorial.faq.modal.user-types.parent',
    className: 'bg-indigo-light-50 text-indigo-secondary',
  },
  [EUserType.SCHOOL]: {
    label: 'editorial.faq.modal.user-types.school',
    className: 'bg-success-light-50 text-success-secondary',
  },
  [EUserType.TEACHER]: {
    label: 'editorial.faq.modal.user-types.teacher',
    className: 'bg-orange-light-50 text-orange-600',
  },
  [EUserType.STUDENT]: {
    label: 'editorial.faq.modal.user-types.student',
    className: 'bg-purple-light-50 text-purple-600',
  },
};

export const DeletedRecordTypeOptions = [
  {
    value: String(ERestoreEntityType.SCHOOL),
    label: 'settings.deleted-records.types.school',
  },
  {
    value: String(ERestoreEntityType.TEACHER),
    label: 'settings.deleted-records.types.teacher',
  },
  {
    value: String(ERestoreEntityType.PARENT),
    label: 'settings.deleted-records.types.parent',
  },
  {
    value: String(ERestoreEntityType.STUDENT),
    label: 'settings.deleted-records.types.student',
  },
  {
    value: String(ERestoreEntityType.CHILD),
    label: 'settings.deleted-records.types.child',
  },
  {
    value: String(ERestoreEntityType.ADMIN),
    label: 'settings.deleted-records.types.admin',
  },
  {
    value: String(ERestoreEntityType.CLASS),
    label: 'settings.deleted-records.types.class',
  },
  {
    value: String(ERestoreEntityType.LESSON),
    label: 'settings.deleted-records.types.lesson',
  },
];

export const CURRENCY_OPTIONS = [
  { value: ECurrency.KWD, label: 'KWD (د.ك)' },
  { value: ECurrency.USD, label: 'USD ($)' },
];

export const CURRENCY_CONFIG: Record<
  ECurrency,
  { symbol: string; decimals: number; prefix: boolean }
> = {
  [ECurrency.KWD]: { symbol: 'د.ك', decimals: 3, prefix: false },
  [ECurrency.USD]: { symbol: '$', decimals: 2, prefix: true },
};

export const SubscriptionStatusConfig = {
  [ESubscriptionStatus.ACTIVE]: {
    label: 'common.subscription-status.active',
    className: 'border border-success-secondary text-success-secondary',
  },
  [ESubscriptionStatus.UPCOMING]: {
    label: 'common.subscription-status.upcoming',
    className: 'border border-brand-default text-brand-default',
  },
  [ESubscriptionStatus.EXPIRED]: {
    label: 'common.subscription-status.expired',
    className: 'border border-error-secondary text-error-secondary',
  },
  [ESubscriptionStatus.EXPIRING_SOON]: {
    label: 'common.subscription-status.expiring-soon',
    className: 'border border-warning-secondary text-warning-secondary',
  },
  [ESubscriptionStatus.CANCELLED]: {
    label: 'common.subscription-status.cancelled',
    className: 'border border-error-secondary text-error-secondary',
  },
};

export const SUBSCRIPTION_PLAN_OPTIONS = [
  { value: 'monthly', label: 'common.subscription-plan.monthly' },
  { value: 'yearly', label: 'common.subscription-plan.yearly' },
];

export const GAME_TAG_COLORS = [
  'border-indigo-600 text-indigo-600 ',
  'border-green-600 text-green-600',
  'border-orange-600 text-orange-600',
] as const;
